import { BsArrowRightShort } from 'react-icons/bs';
import { Button } from '../../core/Button/Button';
import { post } from '../../hooks/posts_hook';
import { TransactionDetails } from '../../types/api.types';
import { useSelector } from 'react-redux';
import { oneticketValidateAPI } from '../../services/oneticket.service';
import { toast } from 'react-toastify';
import { insertTransactionData } from '../../configs/firebaseConfig';
function getFormattedDateTime() {
  const date = new Date();

  // Get components
  const year = date.getFullYear();
  // Months are zero-indexed, so add 1
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  // Construct the date-time string
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
export const Cybersource = () => {
  const paymentDetails: TransactionDetails = useSelector(
    (state: any) => state.payment
  );
  const installmentData = useSelector((state: any) => state.installment);
  console.log(installmentData);
  const submitCybersource = async () => {
    // if (paymentDetails.request_type == "TICKETING") {
    let oneticketData = {
      onepay_transaction_id: paymentDetails.data.onepay_transaction_id,
    };

    const validate_response: any = await oneticketValidateAPI(oneticketData);
    if (validate_response.status !== 200) {
      toast.error('Sorry you took too long to submit payment details.', {
        autoClose: 3000,
      });
      const transactionDetails = {
        is_pay: false, // Set the value accordingly
        merchant_transaction_id: paymentDetails.data.request_transaction_id,
        tran_date: getFormattedDateTime(),
      };
      insertTransactionData(
        paymentDetails.data.onepay_transaction_id,
        transactionDetails
      );

      // Add a small delay before redirecting
      setTimeout(() => {
        window.location.href = paymentDetails.data.transaction_redirect_url;
      }, 3000); // Adjust the delay as needed for your toast duration

      return;
    } else {
      let redirect_request = {
        onepay_transaction_id: paymentDetails.data.onepay_transaction_id,
        ...(installmentData?.isInstallmentSelected &&
          installmentData?.selectedPlanId && {
            installment_plan_id: installmentData.selectedPlanId,
          }),
      };

      post(
        redirect_request,
        process.env.REACT_APP_CYBERSOURCE_REDIRECT_URL ||
          'https://onepay-cybersource-live.onepayapi.lk/api/v3/cybersource/redirect/',
        '_top'
      );
    }

    // else{
    //   let redirect_request = {
    //     onepay_transaction_id: paymentDetails.gateway_transaction_id
    //   };

    //   post(redirect_request, "https://onepay-cyber-checkout-live-dot-spemai-asia.el.r.appspot.com/api/v3/cybersource/redirect/");
    // }
  };
  return (
    <div>
      <div className="ps-3 pe-3 pt-3">
        <Button
          buttonText={paymentDetails.data.app.action_bt_text}
          type="button"
          onClickHandler={() => submitCybersource()}
          icon={<BsArrowRightShort />}
          className="pay-btn"
        />
      </div>
    </div>
  );
};
